export default __webpack_public_path__ + "static/media/element_58.384bbd71.webp";